import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-selection-manager',
  templateUrl: './selection-manager.component.html',
  styleUrls: ['./selection-manager.component.scss']
})
export class SelectionManagerComponent implements OnInit {

  @Output() selectAll = new EventEmitter();
  @Output() selectNone = new EventEmitter();
  @Output() selectInvert = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
